/* Die Produktsuche läuft über Tags, nicht über den Volltext.

   BEFUND

   Shopifys Volltextindex hinkt dem Katalog hinterher. Am 03.08. am laufenden
   Entwicklungsserver gemessen, dieselbe Abfrage mehrfach hintereinander:

       bridgestone        80 / 60 / 37 Treffer     tatsächlich  770
       michelin           46 / 36     Treffer      tatsächlich 1108
       ecopia              0 Treffer               7 Artikel tragen ECOPIA
                                                   im Modellnamen
       ecopia ep150        0 Treffer               Begriffe werden UND-verknüpft

   Die Zahlen schwanken zwischen den Durchläufen — der Index wird bei täglichen
   Importen über 14'000 Produkte laufend neu aufgebaut und kommt nicht nach.

   Die Tag-Suche im selben Moment:

       tag:Bridgestone    770        Reifen mit vendor Bridgestone    770
       tag:Michelin      1108        Reifen mit vendor Michelin      1108
       tag:Reifen       14264        aktive Reifen im Katalog       14264

   Exakt, sofort, ohne Schwankung. Also wird gesucht, was verlässlich ist.

   WEG

   `.claude/scripts/modelltags_setzen.py` hängt den Modellnamen aus
   `custom.modell` als Tags an jedes Produkt — in den Schreibweisen, in denen
   ein Kunde ihn tippt:

       „ECOPIA EP150"  ->  ECOPIA EP150 | ECOPIA | EP150 | ECOPIAEP150

   Dieselbe Datei schreibt `assets/tire-modelle.json`: alle Marken und Modelle
   mit ihren Tags und Artikelzahlen. Dieses Skript liest den Wortschatz und
   lenkt eine passende Eingabe auf die Tag-Abfrage um.

   NUR WAS ES WIRKLICH GIBT

   Umgelenkt wird ausschliesslich auf Tags, die im Wortschatz stehen — und der
   Wortschatz wird aus den Tags gebaut, die NACH dem Schreiben wirklich am
   Produkt hängen, nicht aus den geplanten. Das ist kein Übereifer: Shopify
   nimmt manche Tags stillschweigend nicht an (`tagsAdd` meldet Erfolg, der Tag
   fehlt danach trotzdem — Einzelheiten in modelltags_setzen.py).

   Eine Umleitung ins Leere wäre schlimmer als eine mittelmässige Volltext-
   suche: Der Kunde sähe „keine Treffer" und nicht, dass die Suche ihn
   woandershin geschickt hat. Was der Wortschatz nicht kennt, geht unverändert
   an die Volltextsuche.

   Dasselbe Muster wie assets/tire-groessensuche.js, die getippte Grössen
   abfängt. Die beiden greifen ineinander: Ist die Eingabe eine reine Grösse,
   hat jenes Skript Vorrang und dieses hält sich heraus. */
(function () {
  'use strict';

  function suchPfad() {
    return `${window.Shopify?.routes?.root || '/'}search`.replace(/\/{2,}/g, '/');
  }

  function lokalerPfad(pfad) {
    var roh = String(pfad || '/collections/reifen');
    var wurzel = String(window.Shopify?.routes?.root || window.routes?.root_url || '/');
    if (wurzel === '/' || roh === wurzel || roh.indexOf(wurzel + '/') === 0) return roh;
    return (wurzel.replace(/\/$/, '') + '/' + roh.replace(/^\//, '')).replace(/\/{2,}/g, '/');
  }

  function handle(text) {
    var wert = String(text || '').trim().toLowerCase();
    if (wert.normalize) wert = wert.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return wert.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Exakte Markensuchen gehören auf die indexierbare Marken-Landingpage.
     Die bisherige Tag-Suche zeigte zwar Produkte, aber eine andere (und teils
     kleinere) Trefferzahl als die kanonische Markenseite. */
  function markenAdresse(marke) {
    var basis = window.routes?.tire_collection_url || '/collections/reifen';
    return lokalerPfad(String(basis).replace(/\/$/, '') + '/' + handle(marke));
  }

  /* Nur einmal — die Kopfleiste und die Suchsection binden dieselbe Datei
     ein. Zwei <script>-Tags mit derselben Adresse werden einmal geladen, aber
     zweimal ausgeführt; ohne Sperre stünden alle Zuhörer doppelt. Dieselbe
     Falle wie in tire-groessensuche.js. */
  if (window.vantiqModell) return;

  /* Wie viele Tags eine Präfixsuche höchstens verodern darf.

     „bridgestone ep" soll EP150 und EP510 finden — dafür muss aus dem
     Bruchstück „EP" eine Oder-Gruppe werden. Ohne Deckel würde aus einem
     einzelnen Buchstaben eine Abfrage über hunderte Tags: lange Adresse,
     langsame Antwort, und das Ergebnis ist ohnehin kein Treffer mehr, sondern
     ein Katalog. Über der Grenze bleibt es Volltextsuche. */
  var MAX_ODER = 15;

  /* Saisonwörter sind keine Modelle.

     `custom.modell` steht bei 105 Produkten wörtlich auf „Winter" und bei 95
     auf „Sommer" — deshalb setzt das Python-Skript daraus KEINEN Modelltag.
     Wer „winterreifen" tippt, meint aber sehr wohl etwas, und zwar die
     Saison. Die Tags dafür setzt der Import; sie sind gross und verlässlich
     (tag:Sommerreifen = 7521). */
  var SAISON = {
    winter: 'Winterreifen',
    winterreifen: 'Winterreifen',
    sommer: 'Sommerreifen',
    sommerreifen: 'Sommerreifen',
    ganzjahr: 'Ganzjahresreifen',
    ganzjahres: 'Ganzjahresreifen',
    ganzjahresreifen: 'Ganzjahresreifen',
    allwetter: 'Ganzjahresreifen',
    allwetterreifen: 'Ganzjahresreifen'
  };

  /* --- Wortschatz ------------------------------------------------------- */

  var wortschatz = null;   // aufbereitete Indizes
  var laedt = null;        // das laufende Versprechen

  function quelle() {
    var tag = document.querySelector('script[data-vantiq-modelle]');
    return tag ? tag.getAttribute('data-vantiq-modelle') : null;
  }

  /* Erst laden, wenn jemand die Suche wirklich benutzt.

     Die Datei ist rund 25 KB komprimiert. Sie beim Seitenaufbau zu holen
     würde jeden Besuch belasten, auch die vielen, in denen niemand sucht.
     Geholt wird beim ersten Tastendruck oder beim ersten Fokus — das ist
     Sekunden vor dem Absenden und damit früh genug. */
  function laden() {
    if (laedt) return laedt;
    var url = quelle();
    if (!url) {
      laedt = Promise.resolve(null);
      return laedt;
    }
    laedt = fetch(url)
      .then(function (a) {
        if (!a.ok) throw new Error('Wortschatz antwortete ' + a.status);
        return a.json();
      })
      .then(function (roh) {
        wortschatz = aufbereiten(roh);
        return wortschatz;
      })
      .catch(function (fehler) {
        /* Kein Wortschatz heisst: alles bleibt Volltextsuche. Schlechter als
           mit, aber nicht kaputt. */
        console.warn('[VANTIQ] Modellwortschatz:', fehler);
        wortschatz = null;
        return null;
      });
    return laedt;
  }

  function schluessel(text) {
    /* Vergleichsform: nur Buchstaben und Ziffern, gross. So findet „ep-150",
       „EP 150" und „ep150" denselben Tag — der Kunde tippt keine
       Katalogschreibweise. */
    return String(text || '')
      .toUpperCase()
      .replace(/[^A-Z0-9+]/g, '');
  }

  function aufbereiten(roh) {
    var w = {
      marken: {},      // Vergleichsform -> exakter Marken-Tag
      tags: {},        // Vergleichsform -> exakter Modell-Tag
      zahl: {},        // exakter Tag -> Artikelzahl (für die Rangfolge)
      liste: [],       // alle Marken und Modelle, für Suche und Vorschläge
      woerter: [],     // einwortige Tags, für die Präfixsuche
      stand: roh.stand
    };
    var wortzahl = {};

    function wort(tag, zahl) {
      if (tag.indexOf(' ') !== -1) return;   // mehrwortige Tags nicht
      wortzahl[tag] = Math.max(wortzahl[tag] || 0, zahl);
    }

    (roh.marken || []).forEach(function (e) {
      var name = e[0];
      w.marken[schluessel(name)] = name;
      w.zahl[name] = e[1];
      wort(name, e[1]);
      w.liste.push({
        art: 'marke',
        marke: name,
        text: name,
        tag: name,
        zahl: e[1],
        tags: [name],
        formen: [schluessel(name)]
      });
    });

    (roh.modelle || []).forEach(function (e) {
      var marke = e[0], voll = e[1], zahl = e[2];
      var aliase = e[3] ? e[3].split('|') : [];

      merken(w, voll, zahl);
      wort(voll, zahl);
      aliase.forEach(function (a) {
        merken(w, a, zahl);
        wort(a, zahl);
      });

      /* Womit dieses Modell abgefragt wird: die zusammengezogene Schreibweise,
         wenn es sie als Tag gibt — siehe merken(). `text` bleibt der volle
         Name, denn der gehört in die Vorschlagsliste, nicht in die Adresse. */
      var eng = null;
      for (var a = 0; a < aliase.length; a++) {
        if (aliase[a].indexOf(' ') === -1 && schluessel(aliase[a]) === schluessel(voll)) {
          eng = aliase[a];
          break;
        }
      }

      w.liste.push({
        art: 'modell',
        marke: marke,
        text: voll,
        tag: eng || voll,
        zahl: zahl,

        /* Was wirklich am Produkt hängt. Damit lässt sich nachrechnen, ob
           eine zusammengebaute Abfrage überhaupt etwas treffen kann. */
        tags: [marke, voll].concat(aliase),

        /* Vergleichsformen fürs Suchen — grosszügiger als die Tagliste:
           Auch die EINZELNEN Wörter des Modellnamens stehen hier, selbst die,
           aus denen bewusst kein Tag wurde. Sonst fände „pilot sport" den
           „PILOT SPORT 4" nicht: „SPORT" ist als Tag gesperrt, im Namen steht
           es aber. Gesucht wird damit; umgelenkt wird trotzdem nur auf echte
           Tags. */
        formen: [schluessel(marke), schluessel(voll), schluessel(marke + voll)]
          .concat(aliase.map(schluessel))
          .concat(voll.split(' ').map(schluessel))
          .filter(Boolean)
      });
    });

    /* Häufigstes zuerst — in der Vorschlagsliste und überall dort, wo eine
       Auswahl gekürzt werden muss. */
    w.liste.sort(function (a, b) {
      return b.zahl - a.zahl;
    });
    w.woerter = Object.keys(wortzahl)
      .map(function (t) {
        return { tag: t, k: schluessel(t), zahl: wortzahl[t] };
      })
      .sort(function (a, b) {
        return b.zahl - a.zahl;
      });
    return w;
  }

  function merken(w, tag, zahl) {
    var k = schluessel(tag);
    if (!k) return;

    /* Kollidieren zwei Schreibweisen, gewinnt die OHNE Leerzeichen.

       Nicht Geschmackssache, sondern gemessen. Beide Formen stehen als Tag am
       Produkt, aber Shopify beantwortet sie verschieden:

           tag:CROSSCLIMATE3        83   <- so viele gibt es
           tag:'CROSS CLIMATE 3'    99

       Die mehrwortige Form in Anführungszeichen holt 16 Reifen zu viel; was
       sie zusätzlich trifft, ist von aussen nicht zu sehen. Die zusammen-
       gezogene Form ist exakt. Also wird gefragt, was eine richtige Antwort
       gibt — und nicht, was hübscher in der Adresse aussieht.

       Bei gleicher Form entscheidet die Artikelzahl. */
    var alt = w.tags[k];
    var besser =
      !alt ||
      (alt.indexOf(' ') !== -1 && tag.indexOf(' ') === -1) ||
      (alt.indexOf(' ') === tag.indexOf(' ') && (w.zahl[alt] || 0) < zahl);
    if (besser) w.tags[k] = tag;

    w.zahl[tag] = Math.max(w.zahl[tag] || 0, zahl);
  }

  /* --- Abfrage bauen ---------------------------------------------------- */

  function tagAusdruck(tag) {
    /* Anführungszeichen nur, wenn nötig.

       `tag:'CROSS CLIMATE 3'` muss in Anführungszeichen — ohne sie zerfällt
       der Tag in drei Wörter und Shopify sucht etwas anderes. Ein einwortiger
       Tag darf ohne: Er steht dann auch lesbar in der Adresse und in der
       Überschrift der Ergebnisseite, die den letzten Tag aus der Abfrage
       zieht. */
    return /[\s]/.test(tag) ? "tag:'" + tag + "'" : 'tag:' + tag;
  }

  /* Alle EINWORTIGEN Tags, die mit dem Bruchstück beginnen.

     Ausdrücklich nur einwortige. Die erste Fassung verglich mit der
     leerzeichenlosen Form des ganzen Modellnamens — „EP" traf damit auch
     „E PRIMACY", weil daraus „EPRIMACY" wird. Die Abfrage zu „bridgestone EP"
     schleppte dann neun Michelin-Modelle mit, die durch das UND mit
     `tag:Bridgestone` ohnehin wieder herausfielen: richtiges Ergebnis, aber
     eine Adresse, die niemand mehr lesen kann. */
  function praefix(w, k) {
    if (k.length < 2) return [];
    var treffer = [];
    for (var i = 0; i < w.woerter.length; i++) {
      if (w.woerter[i].k.indexOf(k) === 0) {
        treffer.push(w.woerter[i].tag);
        if (treffer.length > MAX_ODER) return [];   // zu unbestimmt
      }
    }
    return treffer;
  }

  /* Alle Einträge, auf die JEDES getippte Wort passt.

     Dieselbe Rechnung wie in der Vorschlagsliste: ein Wort passt, wenn es der
     Anfang einer der Vergleichsformen ist. Gebraucht wird sie hier als
     Gegenprobe — siehe `aufloesen`. */
  function eintraegeFinden(w, teile) {
    var schluessel_teile = teile.map(schluessel).filter(Boolean);
    if (!schluessel_teile.length) return [];

    var aus = [];
    for (var i = 0; i < w.liste.length; i++) {
      var e = w.liste[i];
      if (e.art !== 'modell') continue;
      var alle = true;
      for (var t = 0; t < schluessel_teile.length; t++) {
        var gut = false;
        for (var f = 0; f < e.formen.length; f++) {
          if (e.formen[f].indexOf(schluessel_teile[t]) === 0) {
            gut = true;
            break;
          }
        }
        if (!gut) {
          alle = false;
          break;
        }
      }
      if (alle) aus.push(e);
    }
    return aus;
  }

  /* Kann diese Abfrage überhaupt etwas treffen?

     Ohne diese Gegenprobe baut die Umleitung Abfragen, die garantiert leer
     sind. „pilot sport" löste sich zu `tag:PILOT AND (tag:SPORTMAXX OR …)`
     auf — beides existiert, aber an keinem Produkt gemeinsam. Null Treffer,
     und der Kunde sieht nicht, warum.

     Geprüft wird gegen den Wortschatz, nicht gegen den Shop: Er trägt zu
     jedem Modell die Liste seiner Tags. */
  function trifftEtwas(w, begriffe) {
    var zu_pruefen = begriffe.filter(function (b) {
      return b.pruefen !== false;
    });
    if (!zu_pruefen.length) return true;

    for (var i = 0; i < w.liste.length; i++) {
      var e = w.liste[i];
      var alle = true;
      for (var b = 0; b < zu_pruefen.length; b++) {
        if (!zu_pruefen[b].tags.some(function (t) {
          return e.tags.indexOf(t) !== -1;
        })) {
          alle = false;
          break;
        }
      }
      if (alle) return true;
    }
    return false;
  }

  /* Die getippte Grösse aus der Wortfolge lösen.

     Rückgabe: {groesse, rest} oder null. Gelesen wird mit demselben Leser wie
     in tire-groessensuche.js — eine zweite, leicht abweichende Fassung wäre
     eine Fehlerquelle. Probiert wird die längste Folge zuerst, damit
     „205 55 16 91v" als Ganzes erkannt wird und nicht nur „205 55 16". */
  function groesseLoesen(teile) {
    var leser = window.vantiqGroesse && window.vantiqGroesse.lesen;
    if (!leser) return null;
    for (var i = 0; i < teile.length; i++) {
      for (var laenge = Math.min(4, teile.length - i); laenge >= 1; laenge--) {
        var g = leser(teile.slice(i, i + laenge).join(' '));
        if (g) {
          return { groesse: g, rest: teile.slice(0, i).concat(teile.slice(i + laenge)) };
        }
      }
    }
    return null;
  }

  /* Ein Begriff der Abfrage: eine oder mehrere Tags, oder-verknüpft. */
  function ausdruck(begriff) {
    if (begriff.tags.length === 1) return tagAusdruck(begriff.tags[0]);
    return '(' + begriff.tags.map(tagAusdruck).join(' OR ') + ')';
  }

  /* Marken, deren Name mit dem Bruchstück beginnt — und die nicht schon
     selbst das Bruchstück sind. Nur bei eindeutiger Lage: Wo mehrere Marken
     in Frage kämen, ist es keine Marke, sondern ein Wortanfang. */
  function markenAnfang(w, k) {
    if (k.length < 3) return [];
    var aus = [];
    for (var mk in w.marken) {
      if (mk !== k && mk.indexOf(k) === 0) aus.push(w.marken[mk]);
    }
    return aus.length === 1 ? aus : [];
  }

  /* ERSTER WEG: die Eingabe wortweise auf ganze Tags abbilden.

     Längste zusammenhängende Wortfolge zuerst — „cross climate 3" ist ein
     Tag, „cross" allein wäre eine schlechtere Antwort auf dieselbe Eingabe.
     Rückgabe null, sobald ein Wort nirgends unterzubringen ist. */
  function genau(w, teile) {
    var begriffe = [];
    var i = 0;
    while (i < teile.length) {
      var getroffen = false;
      for (var bis = teile.length; bis > i; bis--) {
        var stueck = teile.slice(i, bis).join(' ');
        var k = schluessel(stueck);

        var saison = SAISON[stueck.toLowerCase().replace(/[^a-zäöü]/g, '')];
        if (saison) {
          /* Saison-Tags stehen in keinem Modelleintrag; die Gegenprobe muss
             sie überspringen, sonst verwirft sie jede Saisonsuche. */
          begriffe.push({ tags: [saison], pruefen: false });
        } else if (w.marken[k]) {
          begriffe.push({ tags: [w.marken[k]] });
        } else if (w.tags[k]) {
          /* Ein Modelltag, der zugleich der Anfang eines Markennamens ist —
             dann beides.

             „conti" ist als Tag ein Modellwort (Conti Silent, 2 Artikel) und
             gleichzeitig der Anfang von „Continental" (1064). Wer „conti"
             tippt, meint mit grosser Wahrscheinlichkeit die Marke. Statt zu
             raten, welche Lesart die richtige ist, gelten beide: Die Oder-
             Verknüpfung holt zu viel, aber nie zu wenig — und die Vorschlags-
             liste zeigt beim Tippen ohnehin beides getrennt an.

             Betrifft acht Tags im ganzen Katalog: CONTI, GRIP, MASTER, MAX,
             MAXX, ROAD, SUPER, TRAC. */
          begriffe.push({ tags: [w.tags[k]].concat(markenAnfang(w, k)) });
        } else {
          continue;
        }
        i = bis;
        getroffen = true;
        break;
      }
      if (getroffen) continue;

      /* Kein ganzer Tag — dann als Anfang eines Tags versuchen. Genau das ist
         Thomas' Fall: „bridgestone EP" muss den Ecopia EP150 und EP510
         zeigen, nicht ER 300 und Blizzak. „EP" ist kein Tag, aber der Anfang
         von zweien. */
      var kandidaten = praefix(w, schluessel(teile[i]));
      if (!kandidaten.length) return null;
      begriffe.push({ tags: kandidaten });
      i++;
    }
    return begriffe;
  }

  /* Oder-Gruppen auf das eindampfen, was neben den übrigen Begriffen
     überhaupt vorkommen kann.

     „bridgestone EP" löste sich zunächst zu neun Tags auf: `EP150`, `EP510`
     und sieben Formen von Michelins „E PRIMACY", das zusammengezogen
     „EPRIMACY" heisst und damit ebenfalls mit „EP" anfängt. Das UND mit
     `tag:Bridgestone` warf sie ohnehin wieder hinaus — das Ergebnis war
     richtig, die Adresse aber dreimal so lang und für einen Menschen nicht
     mehr nachvollziehbar. Eine Adresse, die man nicht lesen kann, ist eine
     Adresse, der man beim nächsten Fehler nicht ansieht, was schiefging. */
  function straffen(w, begriffe) {
    var fest = begriffe.filter(function (b) {
      return b.pruefen !== false && b.tags.length === 1;
    });
    if (!fest.length) return begriffe;

    var kandidaten = w.liste.filter(function (e) {
      return fest.every(function (b) {
        return e.tags.indexOf(b.tags[0]) !== -1;
      });
    });
    if (!kandidaten.length) return begriffe;

    return begriffe.map(function (b) {
      if (b.tags.length < 2) return b;
      var eng = b.tags.filter(function (t) {
        return kandidaten.some(function (e) {
          return e.tags.indexOf(t) !== -1;
        });
      });
      /* Bleibt nichts übrig, lieber die weite Gruppe stehen lassen — die
         Gegenprobe entscheidet dann. */
      return eng.length ? { tags: eng } : b;
    });
  }

  /* ZWEITER WEG: über die Modelleinträge.

     Greift, wenn der erste Weg scheitert oder etwas gebaut hat, das leer
     bliebe. Gesucht werden alle Modelle, auf die jedes getippte Wort passt —
     danach steht die Frage, wie daraus eine Abfrage wird:

       * wenige Modelle  -> jedes beim Namen nennen, oder-verknüpft. Genau.
       * viele Modelle   -> die Tags nehmen, die ALLE gemeinsam haben. Das
                            holt mehr, als getippt wurde, aber niemals
                            weniger. Zu viel ist hier der bessere Fehler: Der
                            Kunde sieht eine sortierte Liste statt einer
                            abgeschnittenen, die vollständig aussieht. */
  function ueberEintraege(w, teile) {
    var treffer = eintraegeFinden(w, teile);
    if (!treffer.length) return null;

    if (treffer.length <= MAX_ODER) {
      return [{
        tags: treffer.map(function (e) {
          return e.tag;
        })
      }];
    }

    var gemeinsam = treffer[0].tags.filter(function (t) {
      return treffer.every(function (e) {
        return e.tags.indexOf(t) !== -1;
      });
    });
    if (!gemeinsam.length) return null;

    return gemeinsam.map(function (t) {
      return { tags: [t] };
    });
  }

  /* Kern: aus einer Eingabe eine Tag-Abfrage machen — oder nichts.

     Rückgabe {adresse, klartext} oder null. `null` heisst ausdrücklich
     „nicht meine Zuständigkeit"; dann läuft die Volltextsuche wie bisher. */
  function aufloesen(text) {
    var roh = String(text || '').trim();
    if (!roh) return null;

    /* Wer selbst schon `tag:` tippt oder aus einem Filter kommt, weiss, was
       er tut — daran wird nicht herumgebaut. */
    if (/(^|\s)tag:/i.test(roh)) return null;

    var teile = roh.split(/\s+/).filter(Boolean);

    /* Eine reine Grösse gehört tire-groessensuche.js. */
    if (window.vantiqGroesse && window.vantiqGroesse.lesen(roh)) return null;

    var mass = null;
    var g = groesseLoesen(teile);
    if (g) {
      mass = g.groesse;
      teile = g.rest;
    }

    /* Vollständige Grösse plus genau eine Saison braucht weder Modellindex
       noch Shopify-Suche. Dieser wichtigste Einkaufsweg geht direkt auf die
       vollständige saisonale Grössenkollektion. Das funktioniert auch dann,
       wenn `tire-modelle.json` noch lädt oder ausgefallen ist. */
    if (mass && teile.length === 1) {
      var saison = SAISON[teile[0].toLowerCase().replace(/[^a-zäöü]/g, '')];
      var groessenAdresse = window.vantiqGroesse && window.vantiqGroesse.adresse;
      if (saison && groessenAdresse) {
        return {
          adresse: groessenAdresse(mass, saison),
          klartext: roh,
          saison: saison,
        };
      }
    }

    var w = wortschatz;
    if (!w) return null;

    var exakteMarke = !mass && w.marken[schluessel(teile.join(' '))];
    if (exakteMarke) {
      return { adresse: markenAdresse(exakteMarke), klartext: roh, marke: exakteMarke };
    }

    var begriffe = genau(w, teile);
    if (begriffe) begriffe = straffen(w, begriffe);

    /* Gegenprobe: Trifft die zusammengebaute Abfrage überhaupt ein Modell?
       Wenn nicht, war die wortweise Auflösung zu naiv, und der zweite Weg
       bekommt seine Gelegenheit. */
    if (begriffe && !trifftEtwas(w, begriffe)) begriffe = null;

    if (!begriffe) begriffe = ueberEintraege(w, teile);

    if (!begriffe) {
      /* Eine Grösse allein, aber mit einem Wort daneben, das niemand kennt —
         dann lieber Volltextsuche als eine Liste, in der ein Begriff
         stillschweigend verschwunden ist. */
      return null;
    }

    if (!begriffe.length && !mass) return null;

    /* `tag:Reifen` als Grundmenge — dieselbe Tür, die auch die Grössensuche
       und die Filterspalte benutzen. Sie garantiert, dass nur Reifen
       zurückkommen, falls eines Tages ein Marken-Tag auch an Felgen oder
       Zubehör hängt. */
    var abfrage = ['tag:Reifen']
      .concat(begriffe.map(ausdruck))
      .join(' AND ');

    var adresse = suchPfad() + '?type=product&q=' + encodeURIComponent(abfrage);
    if (mass) {
      /* Über Filterparameter, nicht über den Grössen-Tag: Die Filterspalte
         liest sie und zeigt die Grösse als gesetzt an. Siehe
         tire-filter-suche.js, standAusAdresse(). */
      adresse +=
        '&filter.p.m.custom.tire_width=' + mass.breite +
        '&filter.p.m.custom.aspect_ratio=' + mass.quer +
        '&filter.p.m.custom.rim_diameter=' + mass.zoll;
    }

    /* Die Eingabe im Klartext mitgeben.

       Die Ergebnisseite zieht ihre Überschrift sonst aus der Abfrage und
       schriebe „(tag:EP150 OR tag:EP510)" über die Liste. In Liquid sind
       eigene Adressparameter nicht lesbar, also holt sie das Skript unten
       wieder heraus. */
    adresse += '&vq=' + encodeURIComponent(roh);

    return { adresse: adresse, abfrage: abfrage, klartext: roh };
  }

  /* Adresse zu einer fertigen Tag-Liste — für die Vorschlagsliste, die ihre
     Tags schon kennt und nichts mehr auflösen muss. */
  function adresseFuer(tags, klartext) {
    var abfrage = ['tag:Reifen'].concat(tags.map(tagAusdruck)).join(' AND ');
    return (
      suchPfad() + '?type=product&q=' + encodeURIComponent(abfrage) +
      '&vq=' + encodeURIComponent(klartext || tags.join(' '))
    );
  }

  window.vantiqModell = {
    laden: laden,
    aufloesen: aufloesen,
    adresseFuer: adresseFuer,
    markenAdresse: markenAdresse,
    schluessel: schluessel,
    wortschatz: function () {
      return wortschatz;
    }
  };

  /* --- Wortschatz holen, sobald jemand die Suche anfasst ----------------- */

  function istSuchfeld(el) {
    return (
      el &&
      el.tagName === 'INPUT' &&
      el.name === 'q' &&
      el.form &&
      el.form.getAttribute('role') === 'search'
    );
  }

  ['focusin', 'input'].forEach(function (art) {
    document.addEventListener(
      art,
      function (e) {
        if (istSuchfeld(e.target)) laden();
      },
      true
    );
  });

  /* --- Abfangen, bevor das Formular an /search geht ---------------------- */

  document.addEventListener('submit', function (e) {
    /* tire-groessensuche.js hängt am selben Ereignis und ist zuerst dran.
       Hat es die Eingabe als Grösse erkannt und umgeleitet, ist hier nichts
       mehr zu tun. */
    if (e.defaultPrevented) return;

    var form = e.target;
    if (!form || form.getAttribute('role') !== 'search') return;

    var feld = form.querySelector('input[name="q"]');
    if (!feld) return;

    var ziel = aufloesen(feld.value);
    if (!ziel) return;

    e.preventDefault();
    window.location.href = ziel.adresse;
  });

  /* --- Überschrift und Titel auf der Ergebnisseite ----------------------- */

  /* Ohne das steht über der Liste der rohe Tag: „EP510)" statt
     „bridgestone ep". Die Abfrage ist richtig, sie liest sich nur nicht wie
     etwas, das der Kunde eingegeben hat. */
  function ueberschriftRichten() {
    var werte = new URLSearchParams(window.location.search);
    var klartext = werte.get('vq');
    if (!klartext) return;

    var h1 = document.querySelector('h1[id^="suche-"]');
    if (h1) h1.textContent = window.vantiqText('model_search.results_for', { term: klartext });

    var kicker = h1 && h1.parentNode ? h1.parentNode.querySelector('.st-kicker') : null;
    if (kicker) kicker.textContent = window.vantiqText('common.search');

    /* Der Ladenname steht je nach Fall hinter einem senkrechten Strich oder
       hinter einem Gedankenstrich — layout/theme.liquid setzt beides. Wird
       nur auf `|` getrennt, landet der ganze alte Titel als „Ladenname" im
       neuen: „Suche: ecopia | Suche: 3 Ergebnisse gefunden für tag:…". */
    var laden_name = document.title.split(/[|–]/).pop().trim();
    document.title = window.vantiqText('model_search.page_title', { term: klartext }) +
      (laden_name ? ' | ' + laden_name : '');

    /* Das Suchfeld in der Kopfleiste trägt sonst die Tag-Abfrage — der Kunde
       müsste sie löschen, bevor er etwas anderes suchen kann. */
    Array.prototype.forEach.call(
      document.querySelectorAll('form[role="search"] input[name="q"]'),
      function (feld) {
        if (feld.value.indexOf('tag:') !== -1) feld.value = klartext;
      }
    );

    /* Den Klartext auch beim Sortieren mitnehmen.

       Das Sortierformular schickt `q` und die gesetzten Filter erneut ab,
       aber nicht `vq` — nach einem Klick auf „Sortieren" stand über
       derselben Liste plötzlich wieder „EP510)". In Liquid ist der Parameter
       nicht lesbar, also wird er hier nachgetragen. */
    Array.prototype.forEach.call(
      document.querySelectorAll('form.st-sortierung'),
      function (form) {
        if (form.querySelector('input[name="vq"]')) return;
        var feld = document.createElement('input');
        feld.type = 'hidden';
        feld.name = 'vq';
        feld.value = klartext;
        form.appendChild(feld);
      }
    );
  }

  /* --- Nulltreffer, der ein Modell war ----------------------------------- */

  /* Wer über einen alten Link, aus einer Mail oder von einer Suchmaschine auf
     `/search?q=ecopia` kommt, läuft am Formular vorbei und landet in der
     Volltextsuche — dort mit null Treffern. Angeboten wird der Weg, nicht
     still umgeleitet: Der Kunde soll sehen, was mit seiner Eingabe passiert.
     Dieselbe Haltung wie beim Grössenangebot. */
  function nulltrefferAngebot() {
    var platz = document.querySelector('[data-rolle="modell-angebot"]');
    if (!platz) return;

    var werte = new URLSearchParams(window.location.search);
    var q = werte.get('q');
    if (!q) return;

    function anbieten(text, adresse, linktext) {
      var link = document.createElement('a');
      link.href = adresse;
      link.textContent = linktext;
      platz.appendChild(document.createTextNode(text));
      platz.appendChild(link);
      platz.hidden = false;
    }

    /* Der Rückweg.

       Eine Tag-Abfrage ohne Treffer ist eine Sackgasse: Das Suchfeld zeigt
       den Klartext, die Liste ist leer, und der Kunde hat keinen Anhalts-
       punkt, dass es noch einen anderen Weg gibt. Passieren kann das, wenn
       der Wortschatz älter ist als der Katalog — er wird nach dem Import neu
       geschrieben, und dazwischen liegt ein Zeitfenster.

       Die Volltextsuche ist unzuverlässig, aber sie ist nicht nichts. */
    if (q.indexOf('tag:') !== -1) {
      var klartext = werte.get('vq');
      if (klartext) {
        anbieten(
          window.vantiqText('model_search.none', { term: klartext }),
          suchPfad() + '?type=product&q=' + encodeURIComponent(klartext),
          window.vantiqText('model_search.full_text')
        );
      }
      return;
    }

    /* Der Hinweg: `/search?q=ecopia` aus einem Lesezeichen, einer Mail oder
       von einer Suchmaschine läuft am Formular vorbei und landet in der
       Volltextsuche — dort mit null Treffern. Angeboten wird der Weg, nicht
       still umgeleitet: Der Kunde soll sehen, was mit seiner Eingabe
       passiert. Dieselbe Haltung wie beim Grössenangebot. */
    laden().then(function () {
      var ziel = aufloesen(q);
      if (!ziel) return;
      anbieten(
        window.vantiqText('model_search.found', { term: q }),
        ziel.adresse,
        window.vantiqText('model_search.show', { term: q })
      );
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    ueberschriftRichten();
    nulltrefferAngebot();
  });
})();
